import { Component } from "react";
import { ErrorState } from "./Feedback";

// Keeps one failing page (e.g. a lazy chunk that cannot be fetched) from
// blanking the whole workspace.
export default class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <ErrorState
        title="页面加载失败"
        message="请检查网络连接后重新加载；如刚完成系统升级，重新加载即可获取新版本。"
        onRetry={() => window.location.reload()}
      />
    );
  }
}
